var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5,
    width: 40,
    height: 39,
    stroke: "#7232FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.229 30L15.825 25.41H8.805L7.401 30H3L9.804 10.641H14.799L21.63 30H17.229ZM13.449 17.499C13.359 17.193 13.242 16.806 13.098 16.338C12.954 15.87 12.81 15.393 12.666 14.907C12.522 14.421 12.405 13.998 12.315 13.638C12.225 13.998 12.099 14.448 11.937 14.988C11.793 15.51 11.649 16.014 11.505 16.5C11.379 16.968 11.28 17.301 11.208 17.499L9.831 21.981H14.853L13.449 17.499ZM29.8226 14.988C31.1906 14.988 32.3606 15.249 33.3326 15.771C34.3226 16.293 35.0876 17.049 35.6276 18.039C36.1676 19.029 36.4376 20.244 36.4376 21.684V23.628H26.9336C26.9696 24.762 27.3026 25.653 27.9326 26.301C28.5806 26.949 29.4716 27.273 30.6056 27.273C31.5596 27.273 32.4236 27.183 33.1976 27.003C33.9716 26.805 34.7726 26.508 35.6006 26.112V29.217C34.8806 29.577 34.1156 29.838 33.3056 30C32.5136 30.18 31.5506 30.27 30.4166 30.27C28.9406 30.27 27.6356 30 26.5016 29.46C25.3676 28.902 24.4766 28.065 23.8286 26.949C23.1806 25.833 22.8566 24.429 22.8566 22.737C22.8566 21.009 23.1446 19.578 23.7206 18.444C24.3146 17.292 25.1336 16.428 26.1776 15.852C27.2216 15.276 28.4366 14.988 29.8226 14.988ZM29.8496 17.85C29.0756 17.85 28.4276 18.102 27.9056 18.606C27.4016 19.11 27.1046 19.893 27.0146 20.955H32.6576C32.6576 20.361 32.5496 19.83 32.3336 19.362C32.1356 18.894 31.8296 18.525 31.4156 18.255C31.0016 17.985 30.4796 17.85 29.8496 17.85Z",
    fill: "#6D30FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeIcon);
export default __webpack_public_path__ + "static/media/ae_icon.132ea1cb88508b8a57689c238a4a9afd.svg";
export { ForwardRef as ReactComponent };